import { Delete, Edit, ContentCopy } from '@mui/icons-material'
import { preview } from '@/components/form/preview'
import * as Texts from './../../../intl'
import { useDeleteSimulationModal } from '../../../../modals/DeleteSimulationModal'
import { useActions } from '../hooks/useActions'
import { OpenInBrowser } from '@mui/icons-material'

interface Props {
  simulation: uui.domain.client.rm.SimulationInfo
}

export function Header(props: Props) {
  const { simulation } = props
  const actions = useActions(simulation)
  const { Modal: DeleteSimulationModal } = useDeleteSimulationModal()

  return (
    <preview.Header
      title={simulation.name}
      testId="simulation-view-header"
      onClose={actions.onReset}
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<OpenInBrowser />}
          onClick={actions.onOpenSimulation}
          label={Texts.getOpenText()}
          tooltip={Texts.getOpenText()}
          testId="simulation__open"
          data-trackid="simulation__open"
          disableWhenReadOnly={false}
          divider
        />
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={actions.onEdit}
          label={Texts.getEditText()}
          disableWhenReadOnly
          tooltip={Texts.getEditText()}
          testId="simulation__edit"
          data-trackid="simulation__edit"
        />
        <preview.ActionBarItem
          icon={<Delete />}
          onClick={actions.onDelete}
          label={Texts.getDeleteText()}
          tooltip={Texts.getDeleteText()}
          testId="simulation__delete"
          data-trackid="simulation__delete"
          disableWhenReadOnly
        />
        <preview.ActionBarItem
          icon={<ContentCopy />}
          onClick={actions.onDuplicate}
          label={Texts.getDuplicateText()}
          tooltip={Texts.getDuplicateText()}
          testId="simulation__duplicate"
          data-trackid="simulation__duplicate"
          disableWhenReadOnly
        />
      </preview.ActionBar>

      <DeleteSimulationModal simulations={[simulation.id]} />
    </preview.Header>
  )
}
